module.exports = __webpack_public_path__ + "img/withdraw.7ad763ae.png";